import { render } from "./ScrambleText.vue?vue&type=template&id=289b1f8b"
import script from "./ScrambleText.vue?vue&type=script&lang=js"
export * from "./ScrambleText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__